import { createContext } from "react";

import { Dropdown as DropdownComponent, DropdownButton, DropdownIconToggler, DropdownItem } from "./Dropdown";

export const DropdownContext = createContext({
  open: false,
  setOpen: (open: boolean) => {
  }
});

export const Dropdown = Object.assign(DropdownComponent, {
  Button: DropdownButton,
  IconToggler: DropdownIconToggler,
  Item: DropdownItem
});